import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Deposits from '@/pages/Deposits.vue'
import DepositsView from '@/pages/Deposits/View.vue'
import DepositsDetail from '@/pages/Deposits/Detail.vue'
// import DepositEdit from '@/pages/Deposit/Edit.vue'
// import DepositNew from '@/pages/Deposit/New.vue'

import Withdraws from '@/pages/Withdraws.vue'
import WithdrawsView from '@/pages/Withdraws/View.vue'
import WithdrawsDetail from '@/pages/Withdraws/Detail.vue'
// import DepositEdit from '@/pages/Deposit/Edit.vue'
// import DepositNew from '@/pages/Deposit/New.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'
import SettingsTopup from '@/pages/Settings/Topup.vue'

import Clients from '@/pages/Clients.vue'
import ClientsView from '@/pages/Clients/View.vue'
import ClientsEdit from '@/pages/Clients/Edit.vue'
import ClientsDetail from '@/pages/Clients/Detail.vue'
import ClientsBetProviderDetail from '@/pages/Clients/BetProviderDetail.vue'
import ClientsBetUserDetail from '@/pages/Clients/BetUserDetail.vue'
import ClientsBetDetail from '@/pages/Clients/BetDetail.vue'
import ClientsGameDetail from '@/pages/Clients/GameDetail.vue'

import Referral from '@/pages/Referral.vue'
import ReferralView from '@/pages/Referral/View.vue'
import ReferralDetail from '@/pages/Referral/Detail.vue'


import Payments from '@/pages/Payments.vue'
import PaymentsView from '@/pages/Payments/View.vue'

import Reports from '@/pages/Reports.vue'
import ReportsView from '@/pages/Reports/View.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'

import BetReports from '@/pages/BetReports.vue'
import BetReportsView from '@/pages/BetReports/View.vue'

const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: "Settings",
						component: SettingsView
					},
					{
						path: 'topup/:hash_id',
						name: "Settings",
						component: SettingsTopup
					}
				]
			},
			{
				path: 'deposits',
				component: Deposits,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់",
						component: DepositsView
					},
					{
						path: 'detail/:hash_id',
						name: 'ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់',
						component: DepositsDetail
					}
				]
			},
			{
				path: 'withdraws',
				component: Withdraws,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់",
						component: WithdrawsView
					},
					{
						path: 'detail/:hash_id',
						name: 'ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់',
						component: WithdrawsDetail
					}
				]
			},
			{
				path: 'reports',
				component: Reports,
				children: [
					{
						path: '',
						name: "ទិន្នន័យស្ថិតិ",
						component: ReportsView
					}
				]
			},
			{
				path: 'clients',
				component: Clients,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsDetail
					},
					{
						path: 'bet_provider_detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsBetProviderDetail
					},
					{
						path: 'bet_user_detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsBetUserDetail
					},
					{
						path: 'bet_detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsBetDetail
					},
					{
						path: 'game_detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsGameDetail
					},
					{
						path: 'bet_detail/:hash_id/:provider_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsBetDetail
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsEdit
					}
				]
			},
			{
				path: 'referrals',
				component: Referral,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ReferralView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ReferralDetail
					},
				]
			},
			{
				path: 'payments',
				component: Payments,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: PaymentsView
					},
				]
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						name: "Administrators",
						component: AdministratorsView
					},
					{
						path: 'edit/:id',
						name: 'Administrators',
						component: AdministratorsEdit
					}
				]
			},
			{
				path: 'bet_reports',
				component: BetReports,
				children: [
					{
						path: '',
						name: "BetReports",
						component: BetReportsView
					},
				]
			}
		]
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js